// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import API from '@/api/index'
import router from './router'
import store from './store'
import Loading from "@/components/loading/loading"
import VueClipboard from 'vue-clipboard2'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import "@/styles/index.scss"
import "@/styles/common.css"

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

Vue.component("Loading", Loading)
Vue.use(VueClipboard)
Vue.use(Element);


Vue.prototype.$API = API;
Vue.prototype.IMG_URL = '/theme/style2/static/';
Vue.prototype.API_URL = "";
Vue.prototype.IMG_URL = 'https://web-1306364232.file.myqcloud.com/static/';
// Vue.prototype.API_URL = "http://df.daifabashi.cn/";
Vue.config.productionTip = false;

/* eslint-disable no-new */

new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js